import React, {useContext} from "react";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../pages/ProductStencil";
import StockDot from "../../common/StockDot";

export const OverlayProduct = () => {
    const translate = useI18N();
    const {quantityAddedToCart, activeProductIndex, SapDetails, Packaging: PackagingData, product} = useContext(ProductContext);
    const {AEMProdName, StockType, PriceUnit, WeightPrice, WeightUnit, ImageURL} = PackagingData[activeProductIndex];
    const {Packaging} = SapDetails[activeProductIndex];
    const productImageUrl = product.packagings[activeProductIndex].image?.smallUrl || ImageURL;

    return (
        <div className="overlay-content__product">
            <div className="overlay-content__product-image">
                <img src={productImageUrl} alt={AEMProdName} />
            </div>
            <div className="overlay-content__product-info">
                <span className="overlay-content__product-name"><strong>{AEMProdName}</strong></span>
                <div className="overlay-content__product-size">
                    <span>{Packaging}</span>
                    <StockDot stockType={StockType}/>
                </div>
                <div className="overlay-content__product-prices">
                    <span>{quantityAddedToCart} {quantityAddedToCart !== 1 ? translate("units") : translate("unit")}</span>
                    <div>
                        <span><strong>{PriceUnit}</strong>/{translate("unit")}</span>
                        <span><strong>{WeightPrice}</strong>/{WeightUnit}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
